import React, {useState} from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const OrgCard = props => {
    const navigate = useNavigate();

    return(
        <Card sx={{display: 'flex', flexDirection: 'column', height: '100%'}}        >            
            <CardActionArea onClick={() => navigate(`/client/${props.id}`)} disabled={isMobile}>
                <CardContent>
                    <Typography variant="h5" component="div" style={{color:`rgba(8,114,182, ${isMobile ? '0.6' : '1'})`}}>
                        {props.name}
                    </Typography>
                    <Typography sx={{ mb: 1.25 }} color={isMobile ? 'rgba(78,79,83,0.6)' : 'text.secondary'}>
                        {props.industry}
                    </Typography>
                    <Typography variant="body2" style={{color:`rgba(78,79,83, ${isMobile ? '0.6' : '1'})`}}>
                        {`${props.hq_city},${props.hq_state === '' ? ' ' : ` ${props.hq_state}, `}${props.hq_country}`}
                        <br/>
                        {`${props.sites} site${props.sites === 1 ? '' : 's'}`}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions sx={{marginTop: "auto"}}>
                <Button size="small" style={{color:`rgb(0,177,168,${isMobile ? '0.6' : '1'})`}}>Settings</Button>
                {/* <Button size="small" style={{color:'rgb(213,43,0)'}} onClick={() => {
                    props.updateDelClient(props.name, props.id);
                    props.toggleModalState('delete');
                }}>Delete</Button> */}
            </CardActions>
        </Card>
    );
}
 
export default OrgCard;